import { parse, serialize } from 'cookie'

const MIXPANEL_DEVICE_ID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365
const MIXPANEL_DEVICE_ID_COOKIE_ENV_MAP = {
  prod: 'prod',
  production: 'prod',
  preview: 'preview',
  test: 'test',
}

function getNormalizedCookieEnv(env) {
  return env && MIXPANEL_DEVICE_ID_COOKIE_ENV_MAP[env]
    ? MIXPANEL_DEVICE_ID_COOKIE_ENV_MAP[env]
    : 'local'
}

export function getMixpanelDeviceIdCookieName(env = process.env.APP_ENV) {
  const normalizedEnv = getNormalizedCookieEnv(env)
  return 'minware_' + normalizedEnv + '_mixpanel_distinct_id'
}

function readCookie(name) {
  if (typeof document === 'undefined') {
    return undefined
  }

  return parse(document.cookie)[name]
}

function getMinwareCookieDomain(hostname) {
  const normalizedHostname = hostname.toLowerCase()
  if (normalizedHostname === 'minware.com' || normalizedHostname.endsWith('.minware.com')) {
    return '.minware.com'
  }
  return undefined
}

export function readMixpanelDeviceIdCookie() {
  return readCookie(getMixpanelDeviceIdCookieName())
}

export function readMixpanelDistinctId(mixpanel) {
  const mixpanelClient = mixpanel ?? (typeof window !== 'undefined' ? window.mixpanel : undefined)
  const distinctId = mixpanelClient?.get_distinct_id?.()
  if (typeof distinctId === 'string' && distinctId.length > 0) {
    return distinctId
  }
  return undefined
}

export function identifyMixpanelFromDeviceIdCookie(mixpanel) {
  const distinctId = readMixpanelDeviceIdCookie()
  if (!distinctId) {
    return undefined
  }

  mixpanel?.identify?.(distinctId)
  return distinctId
}

export function setMixpanelDeviceIdCookie(distinctId) {
  if (typeof document === 'undefined' || typeof window === 'undefined' || !distinctId) {
    return
  }

  document.cookie = serialize(getMixpanelDeviceIdCookieName(), distinctId, {
    path: '/',
    maxAge: MIXPANEL_DEVICE_ID_COOKIE_MAX_AGE_SECONDS,
    sameSite: 'lax',
    domain: getMinwareCookieDomain(window.location.hostname),
    secure: window.location.protocol === 'https:',
  })
}

export function syncMixpanelDeviceIdCookie(mixpanel) {
  const distinctId = readMixpanelDistinctId(mixpanel)
  setMixpanelDeviceIdCookie(distinctId)
  return distinctId
}
